import { createAction } from 'redux-actions-helpers';

export const check = createAction('@@checked/check', ({ kind, sport, tournament, totalCountTournaments }) => ({
    kind,
    sport,
    tournament,
    totalCountTournaments
}));

export const uncheck = createAction('@@checked/uncheck', ({ kind, globalTournaments, sport, tournament }) => ({
    kind,
    globalTournaments,
    sport,
    tournament
}));

export const updateCountEvents = createAction('@@checked/update-count-events', ({ sports, tournaments }) => ({
    sports,
    tournaments
}));

export const resetCheck = createAction('@@checked/reset-check');



// WEBPACK FOOTER //
// ./src/blocks/checked/actions.js